import { render, staticRenderFns } from "./MenuSale.vue?vue&type=template&id=d76c916e&"
import script from "./MenuSale.vue?vue&type=script&lang=js&"
export * from "./MenuSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports